import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { SharedDataService } from './shared-data.service';

@Injectable()
export class StaticDataService {
  // commit test
  public static options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  public static pageSize = 20;

  public static story_page_id = 'story_main';
  public static header_page_id = "header_main";
  public static story_save_api = 'save_story';
  public static story_liveblogsave_api = 'save_liveblog_story';
  public static story_get_api = 'get_story';
  public static story_version_api = 'versions';
  public static migration_api = 'migration'
  public static element_version_api='element_versions';
  public static story_lockAcquire_api = 'lock_acquire';
  public static story_lockRelease_api = 'lock_release';
  public static story_unlock_api = 'unlock';
  public static secondary_lock_api = 'secondaryLock';
  public static publish_liveblog_post_api = 'publishLiveblogPost'
  public static url_generate_api = 'url_generate';
  public static keywords_generate_api = 'keywords_generate';
  public static element_byids_api = 'element_by_id';
  public static facebook = 'facebook_publish';
  public static twitter = 'twitter_publish';
  public static mobile = 'app_publish';
  public static browser = 'web_publish';

  public static element_page_id = 'element';
  public static element_save_api = 'save_element';
  public static element_get_api = 'get_element';
  public static element_lockAcquire_api = 'lock_acquire';
  public static element_lockRelease_api = 'lock_release';
  public static element_unlock_api = 'unlock';

  public static page_id = 'pages';
  public static page_save_api = 'save_page';
  public static page_get_api = 'get_page';
  public static page_version_api = 'page_versions';
  public static page_lockAcquire_api = 'page_lock_acquire';
  public static page_lockRelease_api = 'page_lock_release';
  public static page_unlock_api = 'page_unlock';
  public static page_delete_articlefrompage = 'delete_articlefrompage';

  public static related_domain_mapping = 'domain_mapping';
  public static related_domain_mapping_embed = 'domain_mapping_embed';

  public static nav_id = 'navManager';
  public static nav_save_api = 'navManagerlist';
  public static nav_get_api = 'putNavManagerlist';
  public static nav_lockAcquire_api = 'nav_lock_acquire';
  public static nav_lockRelease_api = 'nav_lock_release';
  public static nav_unlock_api = 'nav_unlock';

  public static l1_nav_save_api = 'L1navManagerlist';
  public static l1_nav_get_api = 'putL1NavManagerlist';
  public static l1_nav_lockAcquire_api = 'l1_nav_lock_acquire';
  public static l1_nav_lockRelease_api = 'l1_nav_lock_release';
  public static l1_nav_unlock_api = 'l1_nav_unlock';

  public static footer_save_api = 'footerManagerlist';
  public static footer_get_api = 'putfooterManagerlist';
  public static footer_lockAcquire_api = 'footer_lock_acquire';
  public static footer_lockRelease_api = 'footer_lock_release';
  public static footer_unlock_api = 'footer_unlock';


  public static proxyImage = '/image/redirect?link=';

  public static tokenLiteral = 'htUserSessionTokenId';
  public static cacheLiteral = 'htCmsCache';
  public static timeLiteral = 'lastTokenTime';
  public static configTimeLiteral = 'lastConfigTime';
  public static domainLiteral = 'domainId';
  public static tenantName = 'tenantName';
  public static domains_all = 'domains';
  public static allDomains = 'allDomains';
  public static allDomainsUrlMap ="allDomainsMapUrl";
  public static domainsConfigLiteral = 'domainConfig';

  public static fetchTemplates_api = 'web_story_templates';
  //' $ # @ % &
  public static defaultPremiumStoryDays=7;
  //' $ # @ % &
  public static allowSpecialCharKeywordsTags='39,36,35,64,38,32'
  public static livblogShowMaxEle:number=5;
  public static enableSummaryHyperlink='gallery,liveblog';

  // public static twitterEmbedUrl = 'https://publish.twitter.com/oembed?url=';
  // instagram_oembed?url={url}&access_token={access-token}
  // public static instagramEmbedUrl = 'https://graph.facebook.com/v8.0/instagram_oembed?access_token='
  // + 'EAAF2mOpnXeYBAIGZBONc1ENaoEDFl6hUwA1ANElPilPjrTXpjbZAL7vDx8oo3dUzclvlFSysLdqZBiHwOKYnK8CRiIyIgcE0PCXV5LZC9fHT5MR3ccXYdfu8ZBU2Yj1eq0KqEcD2ZCii7GM0lzhPinxhQ33ZAoNLTEuXV8MD6YLns3EQZBLRaon0q6b35RR1ZAHmOSThfleL8HWZCAXp5ZCBEnhu20QllYGoZAUv0MUUZADM744EcAbbYmh3yxL1h37EWBcMZD'
  // + '&url=';

  // public static domainLiteral = 'currentDomain';

  public static regexForComments = new RegExp(
    '<!--[\\s\\S]*?(?:-->)?'
    + '<!---+>?'  // A comment with no body
    + '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?'
    + '|<[?][^>]*>?',  // A pseudo-comment
    'g');

  public static domainUrl = '';

  public static codeForSeperateMessage = [400, 406];

  public static token = localStorage.getItem(StaticDataService.tokenLiteral) ?
    JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)) : null;

  public static defaultStoryData = {
    'id': null,
    'oldUuid': null,
    'oldUuidV2': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'story',
    'createdBy': null,
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'firstPublishedDate': null,
    'lastPublishedBy': null,
    'lastPublishedByUserName':null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lastPublishedHeadline': '',
    'lockedDate': null,
    'introBody': '',
    'metadata': {
      'url': '',
      'jsonSourceUrl': '',
      'redirectUrl': '',
      'authors': [],
      'canonicalUrl': '',
      'charCount': null,
      'wordCount': 0,
      'agency': '',
      'status': 'CREATED',
      'tags': [],
      'keywords': [],
      'section': null,
      'seoUrl': '',
      'subSection': null,
      'subSectionL2': null,
      'topic': [],
      'alternateSection': [],
      'location': [],
      'markUnimportant': false,
      'breakingNews': false,
      'sponsored': false,
      'bigStory': false,
      'syndicationFeed': false,
      'outdatedCheck': false,
      'outdatedTime' : null,
      'editedBy': [],
      'writtenBy': [],
      'reportedBy': [],
      'storyType': 'DIGITAL',
      'agencyByLine': [],
      'videoMetadata': {
        'webcast': false
      },
      'column': '',
      'disclaimer': '',
      'killed': null,
      'killedStatusCode': null,
      'sponsoredTitle': '',
      'metaDescription': '',
      'metaTitle': '',
      'copyFromHeadline':true,
      'ignoreAutoQuickReads':false,
      'affiliateDisclaimer':'',
      'handpicked': false,
      'aiContent':false,
      'autoAddedVideoEmbed':false
    },
    'social': {
      'twitter': false,
      'facebook': false,
      'web': false,
      'mobile': false
    },
    'tagTwitterAuthor': false,
    'socialList': {
      'twitter': []
    },
    'webId': null,
    'elements': [],
    'introElements':[],
    'pinnedArticles': [],
    'headline': '',
    'summary': '',
    'type': '',
    'expireAt': null,
    'expiryDate': null,
    'mobileHeadline': '',
    'mobileAppNotificationHeadline': '',
    'browserNotificationHeadline': '',
    'facebookHeadline': '',
    'twitterHeadline': '',
    'urlHeadline': '',
    'newsletterHeadline': '',
    'h2HeaderHeadline': '',
    'h3HeaderHeadline': '',

    'newsletterSummary': '',
    'leadMedia': {
      'defaultImage': false,
      'elements': [],
      'id': null,
      'mediaType': null,
      'video': null
    },
    'leadMediaGif': {
      'elements': [],
      'id': null,
      'mediaType': null,
    },
    'related': [],
    'showRelated': false,
    'softPublished': false,
    'imageAmpValidated': false,
    'lastPublishedSummary': '',
    'topicMigrated': null,
    'migrationInfoWebUrl':'',
    'migrationInfoWebUrlMigrated': null,
    'topicPublished': null,
    'migrationInfoWebUrlPublished': null,
    'autoPublished': false,
    'crosstenantPhotoGallery':null,
    'webStoryTemplate': false,
    'slideAnimation': null,
    'coverImageUrl': null
  };

  public static defaultParagraphCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': null,
      'subSection': null,
      'topic': [],
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': [],
      'writtenBy': [],
      'reportedBy': [],
      'agencyByLine': [],
      'sponsoredTitle': ''
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': 'paragraph',
    'timestamp': null,
    'type': 'paragraph',
    'paragraph': {
      'body': ''
    },
    'showQuotes': false
  };

  public static defaultListicleElementCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': null,
      'subSection': null,
      'topic': [],
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': [],
      'writtenBy': [],
      'reportedBy': [],
      'agencyByLine': [],
      'sponsoredTitle': ''
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': '',
    'timestamp': null,
    'type': 'listicleElement',
    'paragraph': null,
    'listicleHeadline': null,
    'listicleBulletType':null,
    'listicleArray': [],

  };

  public static defaultImageCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': 0,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': 'Politics',
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': ''
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': '',
    'name': 'paragraph',
    'timestamp': null,
    'type': 'image',
    'paragraph': {
      'body': ''
    },
    'image': {
      'images': {
        '90x60': null,
        '90x90': null,
        'original': null,
        '250x250': null,
        '960x540': null,
        '600x338': null,
        '550x688': null,
        '1600x900': null
      },
      'caption': '',
      'name': '',
      'alternateText': null,
      'imageCredit': '',
      'anchorTag': '',
      'verticalImage': false,
      'sampleImage' : false,
      'overImage': false
    },
    'parentElementId': 0,
    'imageAmpValidated': false,
    "amazonAds": [
      {
        "key": '',
        "value": '',
        "isPresent": false
      },
    ],
    "amazonMeta": false,
    "amazonTitle": '',
    "amazonCheckedItem": false,
  };

  public static defaultSampleImageCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'sampleImagesIdList' : [],
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'sampleimages',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };

  public static defaultPaywallElement = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'sampleImagesIdList' : [],
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'paywall',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };

  public static defaultImageGifCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': 0,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': 'Politics',
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': ''
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': '',
    'name': 'paragraph',
    'timestamp': null,
    'type': 'gif',
    'paragraph': {
      'body': ''
    },
    'image': {
      'images': {
        '90x60': null,
        '90x90': null,
        'original': null,
        '250x250': null,
        '960x540': null,
        '600x338': null,
        '550x688': null,
        '1600x900': null
      },
      'caption': '',
      'name': '',
      'alternateText': null,
      'imageCredit': '',
      'anchorTag': '',
      'verticalImage': false
    },
    'parentElementId': 0,
    'imageAmpValidated': false
  };
  public static defaultVideoCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': 0,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': 'Politics',
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': '',
      'videoMetadata': {
        'duration': null
      }
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': '',
    'name': 'video',
    'timestamp': null,
    'type': 'video',
    'paragraph': null,
    'video': {
      'url': '',
      'body': '',
      'embedUrl': '',
      'caption':'',
      'uploadDate':'',
      'description':'',
      'thumbnailUrl':'',
      'youtubeEmbedBody':'',
      'youtubeEmbedUrl':'',
      'image':{
        'images':{}
      },
    }
  };


  public static defaultSlideData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': 0,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': 'Politics',
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': '',
      'videoMetadata': {
        'duration': null
      }
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': '',
    'name': 'slide',
    'timestamp': null,
    'type': 'slide',
    'paragraph': null,
    'video': {
      'url': '',
      'body': '',
      'embedUrl': ''
    },
    'image': {
      'images': {
        'original': null
      },
      'caption': '',
      'name': '',
      'alternateText': null,
      'imageCredit': '',
      'anchorTag': '',
      'verticalImage': false
    },
    'webStorySlide': [],
    'slideAnimation': null,
    'hasSlideImage': false,
    'ctaText':'',
    'ctaLink':'',
    'ctaLinkWithUtm':'',
    'hasSlideVideo': false,
    'hasLogoImage': false,
    'logoUrl': null,
    'logoPosition': null,
    'relatedStoryData':null
  };

  public static defaultListicleCardData = {
    'articleType': 'element',
    'createdBy': null,
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': null,
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': null,
    'lastModifiedByUserName': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'listicle': {
      'title': '',
      'body': '',
      'inlineElementId': null,
      'product':{
        'categoryName':'',
        'brandName':'',
        'modelName':''
      }

    },
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': null,
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': null,
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'listicle',
    'video': null,
    'webId': '',
    'wireFeedId': null
  };

  public static defaultNewPollCardData = {
    'articleType': 'element',
    'createdBy': null,
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': null,
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': null,
    'lastModifiedByUserName': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': null,
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': null,
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': 'poll',
    'type': 'poll',
    'video': null,
    'webId': '',
    'wireFeedId': null
  };


  public static defaultNewFAQCardData = {
    'articleType': 'element',
    'createdBy': null,
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': null,
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': null,
    'lastModifiedByUserName': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'listicle': {
      'title': '',
      'body': '',
      'inlineElementId': null,
      'product':{
        'categoryName':'',
        'brandName':'',
        'modelName':''
      }

    },
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': null,
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': null,
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': 'faq',
    'type': 'faq',
    'video': null,
    'webId': '',
    'wireFeedId': null
  };

  public static defaultLiveblogCardData = {
    'articleType': 'element',
    'createdBy': null,
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': null,
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': null,
    'lastModifiedByUserName': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': {
      'body': '',
      'inlineElementId': null
    },
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'highlight': false
    },
    'name': '',
    'oldUuid': null,
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': null,
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'liveblog',
    'video': null,
    'webId': '',
    'wireFeedId': null
  };

  public static defaultAutoBackLinkSuggestedList = {
    'articleId': '',
    'autoBacklinkStatus': null,
    'autobacklinkResponse': null,
    'autobacklinkedContent': null,
    'contentByElementAfterAutobacklink': null,
    'contentByElementBeforeAutobacklink': {},
    'domainId':'',
    'elementsAfterAutobacklink': null,
    'elementsBeforeAutobacklink': null,
    'id':'',
    'lastModifiedBy':'',
    'lastModifiedByUserName':'',
    'lastModifiedDate':'',
    'oldContent':'',
    'recommendedContent':{},
    'recommendedLinkedContent':null
  }

  public static defaultRelatedStoryCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'relatedstory',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };

  public static defaultLabelCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'label',
    'label': '',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };

  public static defaultSeparatorCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'separator',
    'separator': '',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };

  public static defaultAlsoReadCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'alsoReadStories' : {},
    'alsoReadStoryIdList' : [],
    'alsoReadStoriesUrl':{},
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'alsoread',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };
  public static defaultRelatedHowtoStoryCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': 0,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'relatedStories': [],
    'relatedStoriesHowTo': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'relatedstoryhowto',
    'video': null,
    'webId': '',
    'wireFeedId': ''
  };

  public static defaultEmbedCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'collectionStoriesVersion': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true,
      'cromaMeta':false,
      'cromaAds':[],
      'flipkartMeta':false,
      'flipkartAds':[],
      'matchDetail':{},
      'date':'',
      'position':'',
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'embed',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'tagTypeApp': '',
    'amazonAds': [],
    'lShapeBand': false
  };

  public static defaultAffilliateEmbedCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'collectionStoriesVersion': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'affiliate' : {
      'name' : null,
      'osp': null,
      'logo': null,
      'url' : null,
      'discount_perc': null,
      'curr_sell_price': null
    },
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    "affiliateMeta": true,
    'type': 'embed',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'tagTypeApp': '',
    'amazonAds': [],
    'lShapeBand': false
  };

  public static defaultFaqCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'collectionStoriesVersion': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': 'FAQ',
    'type': 'faq',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'faqs': [],
    'faqSectionHeading': ''
  };



  public static defaultHowToStepsCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'collectionStoriesVersion': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': 'How To Steps',
    'type': 'howToSteps',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'heading': '',
    'timeToComplete': '',
    'timeToCompleteinHrs': '',
    'supplies': '',
    'tools': '',
    'steps': []
  };
  public static defaultRecipeCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'collectionStoriesVersion': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'recipe': {
      recipeName : null,
      description : null,
      recipeYield : null,
      steps : [],
      preparationTimeHr : null,
      preparationTimeMinute : null,
      cookingTimeHr  : null,
      cookingTimeMinute : null,
      totalTimeHr : null,
      totalTimeMinute : null,
      keywords : null,
      ingredients : null,
      recipeCuisine : null,
      recipeCategory : null
    },
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': 'Recipe',
    'type': 'recipe',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'heading': '',
    'timeToComplete': '',
    'timeToCompleteinHrs': '',
    'steps': []
  };

  public static defaultPodcastCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'collectionStoriesVersion': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': 'Podcast',
    'type': 'podcast',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'podcast': {
      'podcastId': '',
      'podcastTitle': '',
      'podcastContent': '',
      'podcastImage': '',
      'podcastUrl':'',
      'podcastMp3Url':'',
      'podcastPublisher': {
        'id': 0,
        'name':''
      }
    }
  };

  public static defaultMarketCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'stockType':'manual'
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'market',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'indice': {},
    'indicesNew': {},
    'indicesMutualFund': [],
    'indicesMarket': [],
    'indicesList':[]
  };

  public static defaultProductCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'product' : {},
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'productElement',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'indice': {},
    'indicesMutualFund': [],
    'indicesMarket': []
  };

  public static defaultCricketCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': ''
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'cricket',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'indice': {}
  };


  public static defaultjsonfeedCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.domains[0] :
      '5aeab8eefc36f218b0e0866b',
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'jsonfeed',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'tagTypeApp': '',
  };

  public static defaultPlaceholderCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.domains[0] :
      '5aeab8eefc36f218b0e0866b',
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true,
      'banner':{
        'title': '',
        'description':'',
        'imageUrl':'',
        'deeplinkUrl':'',
        'cta':'',
        'design':'Design 2'
      }
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'placeholder',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'tagTypeApp': '',
  };

  public static defaultTopTrendsCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.domains[0] :
      '5aeab8eefc36f218b0e0866b',
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'toptrends',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'trending': []
  };
  public static defaultBannerCardData = {
    'articleType': 'element',
    'createdBy': '',
    'createdDate': null,
    'domainId': JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.domains[0] :
      '5aeab8eefc36f218b0e0866b',
    'embargoAt': null,
    'embargoBy': '',
    'embargoDate': null,
    'id': null,
    'image': null,
    'isDeleted': 0,
    'lastModifiedBy': '',
    'lastModifiedByUserName': '',
    'lastModifiedDate': null,
    'lastPublishedBy': '',
    'lastPublishedDate': null,
    'listicle': null,
    'liveBlog': null,
    'reusable': false,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'agency': '',
      'design': null,
      'externalUrl': null,
      'agencyByLine': [],
      'alternateSection': [
      ],
      'authors': [],
      'breakingNews': false,
      'charCount': 0,
      'editedBy': [],
      'keywords': [],
      'location': [],
      'markUnimportant': false,
      'reportedBy': [],
      'section': '',
      'sponsored': false,
      'status': 'CREATED',
      'subSection': '',
      'tags': [],
      'topic': [],
      'url': '',
      'wordCount': 0,
      'writtenBy': [],
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'embed': {
      'body': '',
      'option': {},
      'url': '',
      'title': '',
      'backgroundColor': '',
      'fontColor': '',
      'labelEnabled': false,
      'label': {
        'text': '',
        'backgroundColor': '',
        'fontColor': ''
      }
    },
    'name': '',
    'oldUuid': '',
    'paragraph': null,
    'readByUsers': [],
    'scheduledAt': 0,
    'scheduledBy': '',
    'scheduledDate': null,
    'social': {},
    'suggest': {
      'input': []
    },
    'timestamp': null,
    'title': '',
    'type': 'banner',
    'video': null,
    'webId': '',
    'wireFeedId': '',
    'jsonSourceUrl': '',
    'subType': '',
    'trending': [],
    'banner':[]
  };

  public static defaultDocumentData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': 0,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': 'Politics',
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': '',
    'name': 'document',
    'timestamp': null,
    'type': 'document',
    'paragraph': null,
    'image': {
      'images': {
        'original': null
      },
      'caption': '',
      'name': '',
      'alternateText': null,
      'imageCredit': ''
    },
    'parentElementId': 0
  };

  public static defaultCollectoionCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'collectionStories': [],
    'collectionPages': null,
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'design': null,
      'keywords': null,
      'section': null,
      'externalUrl': null,
      'subSection': null,
      'name': null,
      'topic': [],
      'alternateSection': [{
        'section': null,
        'subsection': null
      }],
      'location': [
        'Others'
      ],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': 'collection',
    'timestamp': null,
    'type': 'collection',
    'paragraph': {
      'body': ''
    },
    'image': null
  };
  public static defaultCommunitiesCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'collectionStories': [],
    'collectionPages': null,
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'design': null,
      'keywords': null,
      'section': null,
      'externalUrl': null,
      'subSection': null,
      'name': null,
      'topic': [],
      'alternateSection': [{
        'section': null,
        'subsection': null
      }],
      'location': [
        'Others'
      ],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': 'collection',
    'timestamp': null,
    'type': 'communities',
    'paragraph': {
      'body': ''
    },
    'image': null
  };

  public static defaultPageData = {
    'id': null,
    'url': null,
    'name': null,
    'title': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'keywords': [],
    'description': '',
    'about': null,
    'parentSection': null,
    'lastUpdated': null,
    'status': 'CREATED',
    'lastModifiedBy': null,
    'lastPublishedDate': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'pageSubtype' : null,
    'pageSubtypeCategory' : null,
    'creationDate': null,
    'pageType': null,
    'category': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'coverImage': null,
    'pinnedArticles': null,
    'navigation': null,
    'pageArticles': [],
    'images': {},
    'additionalInfo': '',
    'externalUrl': '',
    'subNavigation': [],
    'cssHTMLClass': ''
  };

  public static defaultConfig = {
    'config': {
      'video': {
        'summary': '300'
      },
      'jsonfeed': {
        'subtype': 'true'
      },
      'story': {
        'getTags': 'true',
        'autoEmbed': 'false',
        'syndicationFeed': 'true',
        'autoRelateStory': true,
        'leadVideo': 'false',
        'summaryStripTagDisabled': 'false',
        'primary-location': 'false',
        'vernacular-editor': 'false',
        'newsletter-fields': 'true',
        'captionStripTagDisabled': 'false'
      },
      'image': {
        'download': 'false'
      },
      'liveblog': {
        'pinnedElements': 0
      },
      'subSection': {
        'cardView': 'true'
      }
    },
    'elementsDisabled': [],
    'paragraphToolsDisabled': ['alignment'],
    'notificationPlatformsEnabled': ['app', 'web', 'facebook', 'twitter', 'flash', 'webengage'],
    'imageRatios': ['16:9', '1:1'],
    'disabledStoryType': [],
    'pagesDisabled': []
  };

  public static defaultTableCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': '',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': null,
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': '',
      'app':true,
      'amp':true,
      'web':true
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': 'paragraph',
    'timestamp': null,
    'type': 'table',
    'paragraph': {
      'body': ''
    }
  };

  public static defaultReviewCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': 'Review',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': null,
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': ''
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': 'review',
    'timestamp': null,
    'reusable': true,
    'type': 'review',
    'review': {
      'rating': 0,
      'price': 0,
      'pros': [],
      'cons': [],
      'specification': []
    }
  };

  public static defaultMovieReviewCardData = {
    'id': null,
    'oldUuid': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'title': 'Movie Review',
    'articleType': 'element',
    'createdBy': '',
    'wireFeedId': null,
    'createdDate': null,
    'lastModifiedBy': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'lastPublishedDate': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'metadata': {
      'url': '',
      'authors': [],
      'charCount': null,
      'wordCount': null,
      'agency': null,
      'status': 'CREATED',
      'tags': [],
      'keywords': null,
      'section': null,
      'subSection': null,
      'topic': null,
      'alternateSection': [],
      'location': [],
      'markImportant': false,
      'breakingNews': false,
      'sponsored': false,
      'editedBy': null,
      'writtenBy': null,
      'reportedBy': null,
      'agencyByLine': null,
      'sponsoredTitle': ''
    },
    'social': {
      'twitter': true,
      'facebook': true
    },
    'webId': null,
    'name': 'movie-review',
    'timestamp': null,
    'reusable': true,
    'type': 'movie-review',
    'movieReview': {
      'rating': 0,
      'name': '',
      'description': '',
      'review': '',
      'image': {
        'images': {
          'original': '',
        },
        'caption': '',
        'name': '',
        'alternateText': null,
        'imageCredit': '',
        'anchorTag': '',
        'verticalImage': false,
        'sampleImage' : false,
        'overImage': false
      },
    }
  };

  public static defaultCollegeData = {
    'id': null,
    'collegeName': null,
    'publishLanguage': null,
    'publishedDomains': null,
    'languageData': {
      'english' : {
        'aboutCollege': null,
        'collegeCoverImage': null,
        'collegeLogoImage': null,
        'collegeImages': [],
        'metadata':{
          'campusSize': null,
          'numberOfFaculty': null,
          'numberOfStudents': null,
          'averagePackage': null,
          'officialWebsiteURL': null,
          'address': null,
          'country': null,
          'state': null,
          'city': null,
          'approvedBy': null,
          'rank': null,
          'rankBy': null,
          'typeOfCollege': null,
          'numberOfDepartment': null,
          'numberOfCourses': null,
          'youtubeLink': null,
          'twitterLink': null,
          'numberOfLibraries': null,
          'libraryCollectionDetails': null,
          'numberOfHotels': null,
          'sportsComplex': null,
          'labs': null,
          'numberOfOfferAccepted': null,
          'otherFacility': null,
          'alumni':[],
          'contactPerson': null,
          'phone': null,
          'email':[],
          'collegeBrochureLink':null
        },
        'courses':[]
       },
       'hindi' : {
        'aboutCollege': null,
        'collegeCoverImage': null,
        'collegeLogoImage': null,
        'collegeImages': [],
        'metadata':{
          'campusSize': null,
          'numberOfFaculty': null,
          'numberOfStudents': null,
          'averagePackage': null,
          'officialWebsiteURL': null,
          'address': null,
          'country': null,
          'state': null,
          'city': null,
          'approvedBy': null,
          'rank': null,
          'rankBy': null,
          'typeOfCollege': null,
          'numberOfDepartment': null,
          'numberOfCourses': null,
          'youtubeLink': null,
          'twitterLink': null,
          'numberOfLibraries': null,
          'libraryCollectionDetails': null,
          'numberOfHotels': null,
          'sportsComplex': null,
          'labs': null,
          'numberOfOfferAccepted': null,
          'otherFacility': null,
          'alumni':[],
          'contactPerson': null,
          'phone': null,
          'email':[],
          'collegeBrochureLink': null
        },
        'courses':[]
       }
    }
  }

  public static defaultCelebData = {
    'celebrityName': null,
    'aboutCelebrity': null,
    'celebrityImage': null,
    'metadata':{
      'profession': null,
      'netWorth': null,
      'noOfMoviesDone': null,
      'nickName': null,
      'dob': null,
      'age': null,
      'dateOfDeath': null,
      'zodiac': null,
      'placeOfBirth': null,
      'height': null,
      'weight': null,
      'eyeColor': null,
      'hairColor': null,
      'hometown': null,
      'fatherName': null,
      'motherName': null,
      'siblingName': null,
      'maritalStatus': null,
      'spouseName': null,
      'kidName': [],
      'educationLevel': null,
      'college': null,
      'school': null,
      'status' : 'CREATED',
      'instagramLink': null,
      'facebookLink': null,
      'twitterLink': null,
      'youtubeLink': null,
      'totalAwards': null,
      'deubtMovieOrShowName': null,
      'deubtYear': null
    },
    'awards': [],
    'notableMovies':[]
  }
  public static defaultMovieData = {
    'movieName': null,
    'aboutMovie': null,
    'image': null,
    'reviews':null,
    'metadata':{
      'genre': null,
      'whereToWatch': null,
      'whereToWatchUrl': null,
      'yearOfRelease': null,
      'releaseDate': null,
      'duration': null,
      'status' : 'CREATED',
      'ytChannel': null,
      'twitterLink': null,
      'instagramLink': null,
      'trailerYtLink': null,
      'teaserYtLink': null,
      'director': null,
      'producer': null,
      'cinematography': null,
      'musicDirector': null,
      'screenPlayBy': null,
      'storyBy': null,
      'productionCompany': null,
      'certification': null,
      'budget': null,
      'boxOfficeCollection': null,
      'movieIndustry': null,
      'reviews': null,
    },
    'languages': [],
    'franchiseMovies':[],
    'songLists':[],
    'awards':[],
    'casts':[]

  }

  public static defaultTVShowData = {
    'showName': null,
    'aboutShow': null,
    'image': null,
    'metadata':{
      'genre': null,
      'channel': null,
      'showTiming': null,
      'currentlyActive': null,
      'ytChannel': null,
      'twitterLink': null,
      'status' : 'CREATED',
      'instagramLink': null,
      'firstReleaseDate': null,
      'lastEpisodeDate': null,
      'numberOfSeasons': null,
      'latestSeason': null,
      'language': null,
      'plot': null,
      'director': null,
      'producer': null,
    },
    'awards':[],
    'casts':[]

  }

  public static chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(231,233,237)'
  };

  public static chartColor = [
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(54, 162, 235)',
    'rgb(153, 102, 255)',
    'rgb(231,233,237)'
  ];

  public static LineChartdataset = {
    label: '',
    backgroundColor: null,
    borderColor: null,
    data: [],
    fill: false,
  };

  public static chartConfig = {
    type: 'line',
    data: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      chartArea: {
        backgroundColor: 'rgba(255, 255, 255, 0.4)'
      },
      title: {
        display: true,
        text: ''
      },
      tooltips: {
        mode: 'label',
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: ''
          }
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: ''
          }
        }]
      }
    }
  };

  public static specialCharSymbolMap = new Map<string, string>()
    .set(':', 'charColon')
    .set('>', 'charGreater')
    .set('<', 'charLess')
    .set('!', 'charExclaim')
    .set('~', 'charTide');

  public static removeSpecialCharacters(query) {
    this.specialCharSymbolMap.forEach((value: string, key: string) => {
      const regexConst = new RegExp(key, 'g');
      query = query.replace(regexConst, value);
    });
    return query;
  }

  public static encodeSpecialChar(query) {
    query = encodeURIComponent(this.removeSpecialCharacters(query.trim())).replace(/%3A/g, ':').replace(/%2C/g, ',');
    return query;
  }


}
